/**
 * Shared bounds-checked page navigation for pagination UI components (AM3Pagination,
 * AM3MiniPagination, ...) so "clamp to [1, totalPages], no-op if unchanged" lives in one
 * place instead of being copy-pasted per component.
 */
export function usePaginationNav(
  modelValue: () => number,
  totalPages: () => number,
  onNavigate: (page: number) => void,
) {
  function goToPage(page: number) {
    if (page < 1 || page > totalPages() || page === modelValue()) {
      return
    }

    onNavigate(page)
  }

  return { goToPage }
}
